// extracted by mini-css-extract-plugin
module.exports = {"whiteBg":"LanguagesSelect_whiteBg__2I2ih","main":"LanguagesSelect_main__3VX50"};